import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import { Row, Col, Label, Input, Button, Form } from 'reactstrap';
import CommonModal from '../../Home/modal';
import FeatherIcon from 'feather-icons-react';
import '../../Home/css/userHomePage.css';
import 'react-phone-input-2/lib/style.css'; // Import the styles
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import apiUrl from '../../server';
import NameIcon from '../../../assets/images/MettaMateImages/signature.png'
import Physical from '../../../assets/images/MettaMateImages/women.png';
import Equality from '../../../assets/images/MettaMateImages/wedding-ring.png';
import History from '../../../assets/images/MettaMateImages/calling.png';
import { useApi } from '../../../hooks/useApi'; 
import { profileService, codesService } from '../../../services/api';

const PersonalFunction = () => {
  const { callApi } = useApi();
  let memberID = localStorage.getItem('memberID');
  const [dateValue, setDateValue] = useState(null);
  const [basicData, setBasicData] = useState({});
  const [error, setError] = useState();
  const [success, setSuccess] = useState(); 
  const [phoneNumber, setPhoneNumber] = useState();
  const [countryCode, setCountryCode] = useState('');
  const [value, setValue] = useState();
  const [complexionList, setComplexionList] = useState([]);
  const [maritalStatusList, setmaritalStatusList] = useState([]);
  const [colorList, setcolorList] = useState([]);
  const [genderselectedOption, setgenderSelectedOption] = useState('');
  const [genderList, setGenderList] = useState([]);
  const [bloodgroupList, setbloodgroupList] = useState([]);
  const privacyInfoList = [{ value: 1, label: 'Only Me' },
  { value: 2, label: 'Only Connections' }, { value: 3, label: 'Public' }]
  const [isLoading, setIsLoading] = useState(false);

  const basicdetails = async () => {
    try {
      const response = await callApi(() => 
        profileService.getBasicProfile(memberID)
      );

      if (response.length > 0) {
        setBasicData(response[0]);
        setValue('+' + response[0].phonecountrycode + response[0].phonenumber);
        setCountryCode(response[0].phonecountrycode);
        setPhoneNumber(response[0].phonenumber);
        setgenderSelectedOption(response[0].gender);
      }
    } catch (error) {
      console.error('Error fetching basic details:', error);
    }
  };

  const fetchpersonalDetails = async () => {
    try {
      const response = await callApi(() =>
        profileService.getPersonalProfile(memberID)
      );

      if (response.length > 0) {
        const personalData = response[0];
        setPersonalFormData({
          complexion: personalData.complexion || 0,
          eyecolor: personalData.eyecolor || 0,
          haircolor: personalData.haircolor || 0,
          maritalstatus: personalData.maritalstatus || 0,
          disability: personalData.disability || 0,
          dob: personalData.dob ? format(parseISO(personalData.dob), 'yyyy-MM-dd') : '',
          height: personalData.height || '',
          weight: personalData.weight || '',
          bloodgroup: personalData.bloodgroup || '',
          permission: personalData.permission || '',
        });

        if (personalData.dob) {
          const apiDate = new Date(personalData.dob);
          setDateValue(apiDate);
          const formattedDate = format(apiDate, 'yyyy-MM-dd');
          personalFormData.dob = formattedDate;
        } else {
          setDateValue('');
        }
      }
    } catch (error) {
      console.error('Error fetching personal details:', error);
    }
  };

  const configureDetails = async () => {
    try {
      const response = await axios.get(
        apiUrl + 'members/short/' + localStorage.getItem('memberID'),
        {
          headers: {
            Authorization: 'Bearer' + ' ' + localStorage.getItem('token'),
            'Content-Type': 'application/json',
          },
        },
      );
      localStorage.setItem('configurationData', JSON.stringify(response.data));
    } catch (error) {
      console.log('in error configuration details', error);
    }
  };
  const handleInputChange = (e) => {
    setBasicData({ ...basicData, [e.target.name]: e.target.value });
    personalFormData.firstname = e.target.value;
  };
  const handleLastNchange = (e) => {
    setBasicData({ ...basicData, [e.target.name]: e.target.value });
    personalFormData.lastname = e.target.value;
  };
  const handlegenderOptionChange = (e) => {
    setgenderSelectedOption(e.target.value);
    setBasicData({ ...basicData, [e.target.name]: e.target.value });
    personalFormData.gender = parseInt(e.target.value);
  }
  const handlecontrycodeOnChange = (value, country) => {
    setCountryCode(country.dialCode);
    setPhoneNumber(value.replace(countryCode, ''));
  };
  useEffect(() => {

    fetchpersonalDetails();
    memberID = localStorage.getItem('memberID');
    basicdetails();
    const fetchData = async () => {
      try {
        const [
          complexionRes,
          maritalstsRes, 
          colorRes,
          genderRes,
          bloodgroupRes
        ] = await Promise.all([
          callApi(() => codesService.getComplexion()),
          callApi(() => codesService.getMaritalStatus()),
          callApi(() => codesService.getColors()),
          callApi(() => codesService.getGenders()),
          callApi(() => codesService.getBloodGroups())
        ]);

        setComplexionList(complexionRes.list);
        setmaritalStatusList(maritalstsRes.list);
        setcolorList(colorRes.list);
        setGenderList(genderRes.list);
        setbloodgroupList(bloodgroupRes.list);
      } catch (error) {
        console.error('Error fetching form data:', error);
      }
    };

    fetchData();
    fetchpersonalDetails();
    memberID = localStorage.getItem('memberID');
    basicdetails();
  }, []);

  const [personalFormData, setPersonalFormData] = useState({
    memberuuid: '',
    firstname: '',
    lastname: '',
    dob: '',
    height: '',
    weight: '',
    complexion: '',
    maritalstatus: '',
    disability: '',
    photopath1: '',
    photopath2: '',
    photopath3: '',
    mobileno: '',
    countrycode: '',
    haircolor: '',
    eyecolor: '',
    gender: '',
    mobileno: '',
    bloodgroup: '',
    permission: ''
  });

  const errorHandler = () => {
    setError(null);
  };
  const successHandler = () => {
    setSuccess(null);
  };
  const handleReset = () => {
    setDateValue('');
    setgenderSelectedOption('')
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const formData = {
      ...personalFormData,
      countrycode: countryCode,
      mobileno: phoneNumber,
      gender: genderselectedOption,
      memberuuid: memberID,
      firstname: document.getElementById('firstName').value,
      lastname: document.getElementById('lastName').value,
      height: parseFloat(document.getElementById('height').value),
      weight: parseFloat(document.getElementById('weight').value),
    };

    try {
      const response = await callApi(() => 
        profileService.updatePersonalProfile(formData)
      );

      setSuccess({
        title: 'SUCCESS!',
        message: response.message,
      });

      await Promise.all([
        basicdetails(),
        fetchpersonalDetails()
      ]);
    } catch (error) {
      setError({
        title: 'An Error Occurred!',
        message: error.response?.data?.message || 'Failed to update profile'
      });
    } finally {
      setIsLoading(false);
    }
  };

  const LoaderComponent = () => (
    <div id="preloader">
      <div id="status">
        <div className="spinner">
          <div className="double-bounce1"></div>
          <div className="double-bounce2"></div>
        </div>
      </div>
    </div>
  );
  return (
    <React.Fragment>

      {error && (
        <CommonModal
          title={error.title}
          message={error.message}
          onClose={errorHandler}
          status="error"
        />
      )}

      {success && (
        <CommonModal
          title={success.title}
          message={success.message}
          onClose={successHandler}
          status="success"
        />
      )}
      {
        isLoading ? <LoaderComponent /> :
          (

            <Form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <Row >
                

                <Col md={12} className='mt-3'>
                  {/* <img src={NameIcon} className='legendIcon' /> */}
                  <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.4804 20.0019L14.7504 19.9999C15.9704 19.9999 16.6124 20.5059 17.4034 21.7039L17.7964 22.3119C18.1034 22.7669 18.2954 22.9569 18.5364 23.0569C18.9694 23.2349 19.3284 23.1469 20.6454 22.5129L21.0484 22.3169C21.8724 21.9129 22.4344 21.6809 23.0684 21.5219C23.2614 21.4736 23.4658 21.504 23.6364 21.6064C23.8071 21.7088 23.9301 21.8748 23.9784 22.0679C24.0266 22.261 23.9962 22.4653 23.8938 22.636C23.7914 22.8066 23.6254 22.9296 23.4324 22.9779C23.0384 23.0759 22.6604 23.2179 22.1654 23.4459L21.0064 24.0029C19.4384 24.7429 18.9064 24.8319 17.9654 24.4429C17.3404 24.1859 16.9854 23.8129 16.4654 23.0179L16.2704 22.7139C15.6684 21.7659 15.3654 21.4999 14.7504 21.4999L14.5924 21.5039C14.1594 21.5299 13.8784 21.7279 12.0104 23.1139C10.2684 24.4079 8.93935 25.0249 7.25035 25.0249C5.19035 25.0249 3.24835 24.6469 1.43235 23.8899L4.31435 23.2239C5.25835 23.4239 6.23635 23.5249 7.24935 23.5249C8.53935 23.5249 9.60935 23.0279 11.1164 21.9099L12.2764 21.0539C13.5474 20.1299 13.8304 20.0159 14.4804 20.0019ZM20.7784 2.22189C21.5817 3.02562 22.033 4.1155 22.033 5.25189C22.033 6.38829 21.5817 7.47816 20.7784 8.28189L19.7424 9.31789C20.8944 10.7199 20.8524 12.2049 19.7824 13.2789L16.7814 16.2809C16.7116 16.3505 16.6289 16.4057 16.5378 16.4433C16.4467 16.4809 16.3492 16.5002 16.2506 16.5001C16.1521 16.5 16.0546 16.4805 15.9636 16.4428C15.8726 16.405 15.79 16.3496 15.7204 16.2799C15.6508 16.2102 15.5956 16.1274 15.558 16.0363C15.5203 15.9453 15.501 15.8477 15.5011 15.7492C15.5012 15.6507 15.5207 15.5531 15.5585 15.4621C15.5963 15.3711 15.6516 15.2885 15.7214 15.2189L18.7204 12.2199C19.2054 11.7339 19.2604 11.1299 18.6804 10.3819L8.08535 20.9759C7.78714 21.2739 7.41118 21.4822 7.00035 21.5769L0.920352 22.9809C0.796311 23.0096 0.66699 23.0063 0.544575 22.9713C0.422161 22.9363 0.310683 22.8706 0.220647 22.7806C0.13061 22.6906 0.0649785 22.5791 0.0299367 22.4567C-0.00510507 22.3343 -0.00840349 22.2049 0.0203523 22.0809L1.42335 16.0009C1.5179 15.5897 1.72616 15.2134 2.02435 14.9149L14.7174 2.22189C15.1153 1.82398 15.5876 1.50834 16.1075 1.29299C16.6274 1.07764 17.1846 0.966797 17.7474 0.966797C18.3101 0.966797 18.8673 1.07764 19.3872 1.29299C19.9071 1.50834 20.3805 1.82398 20.7784 2.22189Z" fill="#0D6EFD" />
                  </svg>

                  &nbsp; <span className="m-2 legendName" >Your Full Name</span>

                  <Row className="mt-3">
                    <Col md={5}>
                      <div className="features feature-primary p-1">
                        <div className="mb-3">
                          <div className="form-icon position-relative">
                            <i>
                              <FeatherIcon
                                icon="user"
                                className="fea icon-sm icons"
                              />
                            </i>
                          </div>
                          <Input
                            type="text" required
                            className="form-control ps-5 form_Input form-border-radius"
                            placeholder="First Name"
                            name="firstname"

                            id="firstName"
                            onChange={handleInputChange}
                            value={basicData.firstname || ''}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md={5}>
                      <div className="features feature-primary p-1">
                        <div className="mb-3">
                          <div className="form-icon position-relative">
                            <i>
                              <FeatherIcon
                                icon="user"
                                className="fea icon-sm icons"
                              />
                            </i>
                          </div>
                          <Input
                            type="text"
                            className="form-control form_Input ps-5 form-border-radius"
                            placeholder="Last Name"
                            name="lastname"
                            required
                            id="lastName"
                            onChange={handleLastNchange}

                            value={basicData.lastname || ''}

                          />

                        </div>
                      </div>
                    </Col>
                  </Row>
                  <hr style={{ boxShadow: `0px 1px 1px` }} />
                </Col>

                <Col md={12}>
                  <svg width="29" height="35" viewBox="0 0 29 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25.8834 10.7131L25.8696 10.9117L25.9961 11.0655L28.4233 14.0158C28.4545 14.0562 28.4734 14.0851 28.4845 14.1046L26.6771 14.8536L26.3685 14.9815V15.3155V16.1216V16.6216H26.8679H26.868H26.8682H26.8683H26.8685L26.8685 16.6216L26.8732 16.6217L26.8953 16.622C26.9152 16.6225 26.9446 16.6234 26.9801 16.6252C27.0528 16.6289 27.1444 16.6361 27.2316 16.6494C27.2366 16.6502 27.2414 16.651 27.2461 16.6517V16.7496C27.188 16.758 27.1113 16.7636 27.0167 16.7636C26.8621 16.7636 26.7018 16.7491 26.5761 16.7337C26.5143 16.7261 26.463 16.7185 26.4279 16.713C26.4103 16.7102 26.3969 16.708 26.3883 16.7065L26.3791 16.7049L26.3778 16.7047L26.3776 16.7046C26.3776 16.7046 26.3776 16.7046 26.3775 16.7057L26.0851 17.6537L26.9587 18.0398H26.0441H25.4454L25.5521 18.6289L25.7912 19.95L25.8796 20.9504C25.8591 21.109 25.8289 21.212 25.786 21.3045C25.7384 21.4072 25.6645 21.5204 25.528 21.6923C25.3959 21.8146 25.3023 21.8841 25.2103 21.935C25.1229 21.9834 25.0189 22.0249 24.8568 22.0702H19.574V22.0701L19.5669 22.0702C18.946 22.0791 18.5505 22.1247 17.7344 22.3582L17.711 22.3649L17.6883 22.3738C16.919 22.6777 16.5096 22.9514 15.8404 23.5375L15.8303 23.5464L15.8207 23.5557C15.2366 24.1256 14.9009 24.5087 14.325 25.2079L14.3164 25.2184L14.3084 25.2293C13.8231 25.8882 13.5372 26.3254 13.0611 27.1586L13.0372 27.2004L13.0218 27.246L12.2923 29.3955L12.2804 29.4306L12.2738 29.4671L11.8814 31.6352C11.8506 31.4015 11.8259 31.1486 11.8056 30.8641L11.8058 30.8641L11.8047 30.8525C11.6726 29.4583 11.6896 28.7146 11.8048 27.4521L11.8049 27.4521L11.8057 27.4403C11.8672 26.5312 11.9551 25.9869 12.2704 24.8695C12.6126 23.8808 12.8228 23.3012 13.2256 22.2304C13.7703 21.1085 14.0887 20.5353 14.6437 19.6192C15.3675 18.586 15.7858 18.0036 16.5659 16.9643L18.2462 14.8422C18.4159 14.672 18.5714 14.5158 18.717 14.3696C19.4355 13.6479 19.9116 13.1698 20.652 12.4497L20.6591 12.4428L20.6659 12.4357C21.6469 11.4033 22.1478 10.8541 22.8616 10.0101C22.8933 9.97779 22.9247 9.94587 22.9557 9.91429C24.0414 8.80923 24.7113 8.12737 25.5771 6.73528C25.8242 6.41849 26.033 6.14075 26.2202 5.87397L25.8834 10.7131ZM27.3547 16.7233C27.3546 16.7233 27.3541 16.7236 27.353 16.7241C27.3541 16.7235 27.3547 16.7233 27.3547 16.7233Z" stroke="#0D6EFD" />
                    <path d="M10.2397 10.7477C8.53765 12.3598 6.83285 13.8787 5.61985 15.3154C4.0178 17.1108 2.70205 19.0771 2.70205 19.0771C2.70205 19.0771 1.72945 20.6892 1.24315 22.8388L1 25.257V27.1378L1.24315 29.2873L1.72945 31.7056L2.21575 34.1238" stroke="#0D6EFD" />
                    <path d="M19.7227 2.14941L18.2638 4.83632L16.3186 7.52323C14.6404 9.38377 14.3734 9.59599 13.1577 10.7475C11.4556 12.3597 9.75082 13.8785 8.53782 15.3153C6.93577 17.1107 5.62002 19.0769 5.62002 19.0769C5.62002 19.0769 4.64742 20.6891 4.16112 22.8386L3.91797 25.2568V27.1377L4.16112 29.2872L4.64742 31.7054L5.13372 34.1236" stroke="#0D6EFD" />
                    <path d="M22.1544 2.68713L20.6955 5.37404L18.7503 8.06095C17.0721 9.92149 16.8051 10.1337 15.5893 11.2852M8.05166 19.6147C8.05166 19.6147 7.07906 21.2268 6.59276 23.3763L6.34961 25.7945V27.6754L6.59276 29.8249L7.07906 32.2431L7.56536 34.6613" stroke="#0D6EFD" />
                    <path d="M25.0723 2.68713L23.6134 5.37404L21.6682 8.06095C19.99 9.92149 19.723 10.1337 18.5073 11.2852C16.8052 12.8974 15.1004 14.4163 13.8874 15.853C12.2854 17.6484 10.9696 19.6147 10.9696 19.6147C10.9696 19.6147 9.99703 21.2268 9.51073 23.3763L9.26758 25.7945V27.6754L9.51073 29.8249L9.99703 32.2431L10.4833 34.6613" stroke="#0D6EFD" />
                    <path d="M11.4858 6.23025L11.4554 6.26383L11.422 6.23025C9.97825 4.78267 9.02389 3.82546 9.02389 2.85482C9.02389 2.18309 9.4798 1.6793 10.0877 1.6793C10.5557 1.6793 11.0116 2.01516 11.1727 2.47193H11.7381C11.8991 2.01516 12.355 1.6793 12.8231 1.6793C13.431 1.6793 13.8869 2.18309 13.8869 2.85482C13.8869 3.82546 12.9325 4.78267 11.4858 6.23025ZM12.8231 1.00757C12.2943 1.00757 11.7867 1.27962 11.4554 1.70616C11.1241 1.27962 10.6165 1.00757 10.0877 1.00757C9.15154 1.00757 8.41602 1.817 8.41602 2.85482C8.41602 4.12102 9.4494 5.15884 11.0147 6.72732L11.4554 7.17066L11.8961 6.72732C13.4614 5.15884 14.4948 4.12102 14.4948 2.85482C14.4948 1.817 13.7592 1.00757 12.8231 1.00757Z" fill="#0D6EFD" />
                    <path d="M19.1459 33.1665L19.1155 33.2001L19.0821 33.1665C17.6384 31.719 16.684 30.7617 16.684 29.7911C16.684 29.1194 17.14 28.6156 17.7478 28.6156C18.2159 28.6156 18.6718 28.9514 18.8329 29.4082H19.3982C19.5593 28.9514 20.0152 28.6156 20.4833 28.6156C21.0911 28.6156 21.547 29.1194 21.547 29.7911C21.547 30.7617 20.5927 31.719 19.1459 33.1665ZM20.4833 27.9438C19.9544 27.9438 19.4468 28.2159 19.1155 28.6424C18.7843 28.2159 18.2767 27.9438 17.7478 27.9438C16.8117 27.9438 16.0762 28.7533 16.0762 29.7911C16.0762 31.0573 17.1096 32.0951 18.6748 33.6636L19.1155 34.1069L19.5563 33.6636C21.1215 32.0951 22.1549 31.0573 22.1549 29.7911C22.1549 28.7533 21.4194 27.9438 20.4833 27.9438Z" fill="#0D6EFD" />
                    <path d="M1.97266 8.32923C3.49672 8.32923 4.16101 7.62069 4.16101 5.91101C4.16101 7.62069 4.82067 8.32923 6.34936 8.32923C4.82067 8.32923 4.16101 9.05819 4.16101 10.7474C4.16101 9.05819 3.49672 8.32923 1.97266 8.32923Z" stroke="#0D6EFD" strokeWidth="1.5" strokeLinejoin="round" />
                    <path d="M1.97266 8.32923C3.49672 8.32923 4.16101 7.62069 4.16101 5.91101C4.16101 7.62069 4.82067 8.32923 6.34936 8.32923C4.82067 8.32923 4.16101 9.05819 4.16101 10.7474C4.16101 9.05819 3.49672 8.32923 1.97266 8.32923Z" stroke="#0D6EFD" strokeLinejoin="round" />
                    <path d="M23.8555 26.7349C25.1255 26.7349 25.6791 26.1445 25.6791 24.7197C25.6791 26.1445 26.2288 26.7349 27.5027 26.7349C26.2288 26.7349 25.6791 27.3424 25.6791 28.7501C25.6791 27.3424 25.1255 26.7349 23.8555 26.7349Z" stroke="#0D6EFD" strokeLinejoin="round" />
                  </svg>

                  {/* <img src={Physical} className='legendIcon' style={{ width: `40px` }} /> */}
                  <span className="m-2 legendName" >Aesthetics</span>

                  <Row className="mt-3">
                    <Col md={12} sm={12} xs={12}>
                      <div className="features feature-primary py-0 ">
                        <div className="mb-3">
                          <Label className="form-label label_text">
                            Complexion
                          </Label>
                          <section className="radio-section">
                            <div className="radio-list">
                              {(complexionList || []).map((type, index) => (
                                <div className="radio-item" key={index} >
                                  <Input name="complexionradio" type="radio" value={type.value}
                                    checked={personalFormData.complexion === type.value} id={`radiocomplexion${index}`}
                                    onChange={event => setPersonalFormData({ ...personalFormData, complexion: type.value })} />
                                  <label htmlFor={`radiocomplexion${index}`}>  {type.label}</label>

                                </div>
                              ))}
                            </div>
                          </section>
                        </div>
                      </div>
                    </Col>

                    <Col md={12} xs={12}>
                      <div className=" features feature-primary d-flex justify-content-center py-0">
                        <div className="mb-3 col-md-12">
                          <Label className="form-label label_text">
                            Hair Color
                          </Label>

                          <section className="radio-section">
                            <div className="radio-list">
                              {(colorList || []).map((type, index) => (
                                <div className="radio-item" key={index}  >
                                  <Input name="colorradio" type="radio" value={type.value} className={`inputcolor${index}`}
                                    checked={personalFormData.haircolor === type.value} id={`radiocolor${index}`}
                                    onChange={event => setPersonalFormData({ ...personalFormData, haircolor: type.value })} />
                                  <label htmlFor={`radiocolor${index}`} className={`labelcolor${index}`} style={{ color: type.colorcode }}>  {type.label}</label>

                                </div>
                              ))}

                            </div>
                          </section>
                        </div>
                      </div>
                    </Col>

                    <Col md={12} xs={12}>
                      <div className=" features feature-primary py-0">
                        <div className="mb-3">
                          <Label className="form-label label_text">
                            Eye Color
                          </Label>
                          <section className="radio-section">
                            <div className="radio-list">
                              {(colorList || []).map((type, index) => (
                                <div className="radio-item" key={index}  >
                                  <Input name="eyecolorradio" type="radio" value={type.value} className={`inputcolor${index}`}
                                    checked={personalFormData.eyecolor === type.value} id={`radioeyecolor${index}`}
                                    onChange={event => setPersonalFormData({ ...personalFormData, eyecolor: type.value })} />
                                  <label htmlFor={`radioeyecolor${index}`} className={`labelcolor${index}`} style={{ color: type.colorcode }}>  {type.label}</label>

                                </div>
                              ))}
                            </div>
                          </section>
                        </div>
                      </div>
                    </Col>
                    <Col md={2} sm={12} xs={12}>
                      <div className="features feature-primary pt-1">
                        <div className="mb-3">
                          <Label className="form-label label_text">
                            Height
                          </Label>
                          <div className="form-icon position-relative">
                            <i>
                              <FeatherIcon icon="user" className="fea icon-sm icons" />
                            </i>
                          </div>
                          <div className="form-icon position-absolute" style={{ left: `80%`, top: `46px`, fontSize: `16px` }}>
                            .ft
                          </div>
                          <Input
                            type="text"
                            className="form-control form_Input ps-5"
                            placeholder="Height"
                            name="height"
                            id="height"
                            defaultValue={personalFormData.height}

                          />

                          <Label className="form-label label_text">

                          </Label>

                        </div>
                      </div>
                    </Col>
                    <Col md={2} sm={12} xs={12}>
                      <div className=" features feature-primary pt-1">
                        <div className="mb-3">
                          <Label className="form-label label_text">
                            Weight
                          </Label>
                          <div className="form-icon position-relative">
                            <i>
                              <FeatherIcon icon="user" className="fea icon-sm icons" />
                            </i>
                          </div>
                          <div className="form-icon position-absolute" style={{ left: `80%`, top: `46px`, fontSize: `16px` }}>
                            Kg
                          </div>
                          <Input
                            type="text"
                            className="form-control form_Input ps-5"
                            placeholder="Weight"
                            name="weight"
                            id="weight"
                            defaultValue={personalFormData.weight}

                          />
                        </div>
                      </div>
                    </Col>

                  </Row>
                  <hr style={{ boxShadow: `0px 1px 1px` }} />
                </Col>

                <Col md={12}>
                  {/* <img src={Equality} className='legendIcon' /> */}
                  <svg width="47" height="34" viewBox="0 0 47 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_269_2631)">
                      <path d="M8.90776 8.86895L8.77859 10.8717L10.0716 10.1252L10.2008 8.12241L8.90776 8.86895ZM11.1116 7.59659L10.9825 9.59928L13.9741 7.87207L12.1752 6.98249L11.1116 7.59659ZM13.086 6.45662L14.8851 7.34613L16.1781 6.59959L14.3791 5.71007L13.086 6.45662ZM9.42294 11.5101L12.7509 12.4018L10.4778 10.901L9.42294 11.5101ZM11.3251 10.4119L14.7527 12.6749L14.5066 8.57499L11.3251 10.4119ZM15.3538 8.08587L15.517 10.8048L16.4087 7.47683L15.3538 8.08587ZM10.4695 12.6964C8.23626 15.6645 7.84992 19.8051 9.82014 23.2176C12.4497 27.7722 18.3016 29.3401 22.8561 26.7105C27.4107 24.0809 28.9788 18.2292 26.3491 13.6746C24.3789 10.2621 20.5999 8.52632 16.9129 8.97631L16.3699 11.0028C19.5572 10.2624 22.9718 11.6421 24.6962 14.6289C26.8101 18.2902 25.5631 22.9439 21.9019 25.0577C18.2406 27.1715 13.5869 25.9245 11.4731 22.2633C9.74865 19.2765 10.2611 15.6295 12.496 13.2394L10.4695 12.6965L10.4695 12.6964Z" fill="#0D6EFD" />
                    </g>
                    <g clipPath="url(#clip1_269_2631)">
                      <path d="M30.7614 5.35187L29.2539 6.67669L30.6961 7.06313L32.2036 5.73831L30.7614 5.35187ZM33.2194 6.01049L31.712 7.33534L35.0487 8.22941L34.4057 6.32837L33.2194 6.01049ZM35.4216 6.60058L36.0647 8.50166L37.507 8.8881L36.8638 6.98702L35.4216 6.60058ZM29.2581 7.58372L30.9808 10.5675L30.4347 7.89898L29.2581 7.58372ZM31.3797 8.1522L32.2031 12.176L34.9282 9.10296L31.3797 8.1522ZM35.8732 9.35622L34.066 11.3942L37.0497 9.67149L35.8732 9.35622ZM29.1592 9.16259C25.4814 9.6822 22.2804 12.3369 21.2605 16.143C19.8993 21.223 22.9285 26.4696 28.0084 27.8308C33.0884 29.1919 38.335 26.1629 39.6962 21.0829C40.7161 17.2767 39.2712 13.3772 36.3459 11.0882L34.529 12.1372C37.3063 13.8675 38.7452 17.2576 37.8526 20.5889C36.7584 24.6725 32.586 27.0814 28.5024 25.9873C24.4188 24.8931 22.0099 20.7206 23.1041 16.6371C23.9967 13.3057 26.9379 11.0892 30.2082 10.9796L29.1592 9.16268L29.1592 9.16259Z" fill="#0D6EFD" />
                    </g>
                    <defs>
                      <clipPath id="clip0_269_2631">
                        <rect width="24.8897" height="24.8897" fill="white" transform="translate(0.25 12.4449) rotate(-30)" />
                      </clipPath>
                      <clipPath id="clip1_269_2631">
                        <rect width="24.8897" height="24.8897" fill="white" transform="translate(22.1104 1.7583) rotate(15)" />
                      </clipPath>
                    </defs>
                  </svg>

                  &nbsp; <span className="m-2 legendName" >Identity</span>

                  <Row className="mt-3">
                    <Col md={12} xs={12}>
                      <div className=" features feature-primary py-0">
                        <div className="mb-3">
                          <Label className="form-label label_text">
                            Gender  <span className="text-danger">*</span>
                          </Label>
                          <section className="radio-section">
                            <div className="radio-list">
                              {(genderList || []).map((type, index) => (
                                <div className="radio-item" key={index}  >
                                  <Input name="genderradio" type="radio" defaultValue={type.value}
                                    checked={genderselectedOption == type.value} id={`radiogender${index}`}
                                    onChange={handlegenderOptionChange} />
                                  <label htmlFor={`radiogender${index}`}> {type.label}</label>
                                </div>
                              ))}

                            </div>
                          </section>
                        </div>
                      </div>
                    </Col>


                    <Col md={12} sm={12} xs={12}>
                      <div className="features feature-primary py-0 ">
                        <div className="mb-3">
                          <Label className="form-label label_text">
                            Marital Status
                          </Label>

                          <section className="radio-section">
                            <div className="radio-list">
                              {(maritalStatusList || []).map((item, key) => (
                                <div className="radio-item" key={key} >
                                  <Input name="maritalradio" id={`maritalradio${key}`} type="radio" value={item.value}
                                    checked={personalFormData.maritalstatus === item.value}
                                    onChange={event => setPersonalFormData({ ...personalFormData, maritalstatus: item.value })} />
                                  <label htmlFor={`maritalradio${key}`}> {item.label}</label>
                                </div>
                              ))}
                            </div>
                          </section>


                        </div>
                      </div>
                    </Col>

                    <Col md={12} sm={12} xs={12}>
                      <div className="features feature-primary py-0 ">
                        <div className="mb-3">
                          <Label className="form-label label_text">
                            Disability if any?
                          </Label>
                          <section className="radio-section">
                            <div className="radio-list">
                              <div className="radio-item">
                                <input
                                  name="disability"
                                  id="yesradio"
                                  type="radio"
                                  value="1"
                                  checked={personalFormData.disability == 1}
                                  onChange={event => setPersonalFormData({ ...personalFormData, disability: 1 })}
                                />
                                <label htmlFor="yesradio">Yes</label>
                              </div>
                              <div className="radio-item">
                                <input
                                  name="disability"
                                  id="noradio"
                                  type="radio"
                                  value="2"
                                  checked={personalFormData.disability == 2}
                                  onChange={event => setPersonalFormData({ ...personalFormData, disability: 2 })}
                                />
                                <label htmlFor="noradio">No</label>
                              </div>
                            </div>
                          </section>

                        </div>
                      </div>
                    </Col>

                  </Row>
                  <hr style={{ boxShadow: `0px 1px 1px` }} />
                </Col>

                <Col md={12}>
                  {/* <img src={History} className='legendIcon' /> */}
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4V2H22V4H12ZM12 8V6H22V8H12ZM12 12V10H22V12H12ZM18.95 22C16.8667 22 14.8083 21.546 12.775 20.638C10.7417 19.73 8.89167 18.4423 7.225 16.775C5.55833 15.1083 4.271 13.2583 3.363 11.225C2.455 9.19167 2.00067 7.13333 2 5.05C2 4.75 2.1 4.5 2.3 4.3C2.5 4.1 2.75 4 3.05 4H7.1C7.33333 4 7.54167 4.07933 7.725 4.238C7.90833 4.39667 8.01667 4.584 8.05 4.8L8.7 8.3C8.73333 8.56667 8.725 8.79167 8.675 8.975C8.625 9.15833 8.53333 9.31667 8.4 9.45L5.975 11.9C6.30833 12.5167 6.704 13.1127 7.162 13.688C7.62 14.2633 8.12433 14.8173 8.675 15.35C9.19167 15.8667 9.73333 16.346 10.3 16.788C10.8667 17.23 11.4667 17.634 12.1 18L14.45 15.65C14.6 15.5 14.796 15.3877 15.038 15.313C15.28 15.2383 15.5173 15.2173 15.75 15.25L19.2 15.95C19.4333 16.0167 19.625 16.1377 19.775 16.313C19.925 16.4883 20 16.684 20 16.9V20.95C20 21.25 19.9 21.5 19.7 21.7C19.5 21.9 19.25 22 18.95 22ZM5.025 10L6.675 8.35L6.25 6H4.025C4.10833 6.68333 4.225 7.35833 4.375 8.025C4.525 8.69167 4.74167 9.35 5.025 10ZM13.975 18.95C14.625 19.2333 15.2877 19.4583 15.963 19.625C16.6383 19.7917 17.3173 19.9 18 19.95V17.75L15.65 17.275L13.975 18.95Z" fill="#0D6EFD" />
                  </svg>

                  &nbsp; <span className="m-2 legendName" >Records </span>
                  <Row className="mt-3">

                    <Col md={3} xs={12}>
                      <div className=" features feature-primary py-0">
                        <div className="mb-3">
                          <Label className="form-label label_text ">
                            Mobile Number
                          </Label>
                          <PhoneInput
                            className="  form_Input form_Input"
                            style={{ width: '100%' }}
                            international
                            minLength={10}
                            maxLength={13}
                            required
                            country={'in'}
                            value={value}
                            onChange={handlecontrycodeOnChange}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md={8}>
                      <div className="features feature-primary py-0 ">
                        <div className="mb-3">
                          <Label className="form-label label_text">
                            Permission
                          </Label>
                          <section className="radio-section">
                            <div className="radio-list">
                              {(privacyInfoList || []).map((type, index) => (
                                <div className="radio-item" key={index} >
                                  <Input name="permissionradio" type="radio" value={type.value}
                                    checked={personalFormData.permission === type.value} id={`radiopermission${index}`}
                                    onChange={event => setPersonalFormData({ ...personalFormData, permission: type.value })} />
                                  <label htmlFor={`radiopermission${index}`}>  {type.label}</label>

                                </div>
                              ))}
                            </div>
                          </section>
                        </div>
                      </div>
                    </Col>

                    <Col md={3} xs={12}>
                      <div className="features feature-primary p-1">
                        <div className="mb-3">
                          <Label className="form-label label_text">
                            Date Of Birth
                          </Label>
                          <br />
                          <input type="date" className='form-control' defaultValue={personalFormData.dob}
                            onChange={event => setPersonalFormData({ ...personalFormData, dob: event.target.value })} />
                        </div>
                      </div>
                    </Col>


                  </Row>

                </Col>

                <Col md={12} sm={12} xs={12}>
                  <div className="features feature-primary py-0 ">
                    <div className="mb-3">
                      <Label className="form-label label_text">
                        Blood Group
                      </Label>
                      <section className="radio-section">
                        <div className="radio-list">
                          {(bloodgroupList || []).map((type, index) => (
                            <div className="radio-item" key={index} >
                              <Input name="bloodradio" type="radio" value={type.value}
                                checked={personalFormData.bloodgroup === type.value} id={`radiobloodgroup${index}`}
                                onChange={event => setPersonalFormData({ ...personalFormData, bloodgroup: type.value })} />
                              <label htmlFor={`radiobloodgroup${index}`}>  {type.label}</label>

                            </div>
                          ))}
                        </div>
                      </section>
                    </div>
                  </div>
                </Col>
                <hr style={{ boxShadow: `0px 1px 1px` }} />

                <div className="mt-md-4 mt-3 mb-2 mt-sm-0 text-md-end">
                  <button
                    type="submit"
                    className="btn btn-outline-primary mt-2 "

                  >
                    {' '}
                    Save Changes{' '}
                  </button>{' '}
                  <button type="reset"
                    onClick={handleReset}
                    className="btn btn-outline-secondary mt-2 ms-2  "
                  >
                    Reset
                  </button>
                </div>
              </Row>
            </Form>
          )
      }
    </React.Fragment>
  );
};
export default PersonalFunction;
